'use es6';

import { Record } from 'immutable';
const ScrollPercentageTrigger = new Record({
  enabled: false,
  scrollPercentage: 50
}, 'ScrollPercentageTrigger');
export default ScrollPercentageTrigger;